/** Default visible columns in left-to-right display order (table schema order can differ). */
export const INVOICES_TABLE_DEFAULT_VISIBLE_KEYS = [
  'sf_building_name',
  'invoice_id',
  'payment',
  'invoice_status',
  'total_amount',
  'balance',
  'due_date',
  'dispute_status',
  'actions',
];

/** Bump when default columns/order change so persisted prefs reset. */
export const INVOICES_TABLE_STORAGE_KEY = 'invoices-list-v3';
